import './ingest-file-links-sk';
